import React, { useContext } from 'react'
import ReactDOM from 'react-dom'
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import DiscountForm from './forms/discount_form/DiscountForm'
import CloseButton from '../../layout/close_button/CloseButton'
import AddCashForm from './forms/AddCashForm'
import AddChequeForm from './forms/AddChequeForm'
import { ContentInner } from '../../layout/Content'
import ReceiptInnerStyle from './css/ReceiptInnerStyle'
import { receiptControllerContext } from './ReceiptController'
import { formatNumber } from '../../utilities/utilities'

function PaymentOptionsBlock(props) {
  const [receipt, setReceipt] = props.receipt
  const receiptsList = props.receiptsList
  const { addPayments } = props

  const onClickAddCash = (e) => {
    const addCashFormProps = {
      payments: receipt.payments,
      addPayments
    }

    ReactDOM.render (
      <ModalWindow
        id='mw-parent'
        height= '30'
        width='30'
        header='Add Cash Payment'
        footer={null}>
        <AddCashForm { ...addCashFormProps }/>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickAddCheque = (e) => {
    const addChequeFormProps = {
      payments: receipt.payments,
      addPayments
    }

    ReactDOM.render (
      <ModalWindow
        id='mw-parent'
        width='50'
        header='Add Cheque Payment'
        footer={null}>
        <AddChequeForm { ...addChequeFormProps }/>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickDiscount = (e) => {
    const cb = (res) => { ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container')) }

    const discountFormProps = { receiptsList, receipt, setReceipt, cb }
    ReactDOM.render(
      <ModalWindow
        header="Add/Set Discount's"
        footer={null}
        width={60}
        height={80}>
        <DiscountForm {...discountFormProps}/>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  return (
    <div id='payment-options-block-container'>
      <div id='paid-by-input-container'>
        <label>Receipt Date</label>
        <input
          type='date'
          value={receipt.receipt_date}
          onChange={(e) => setReceipt({...receipt, receipt_date: e.target.value})}
        />
      </div>
      <div id='paid-by-input-container'>
        <label>Paid By</label>
        <input
          type='text'
          value={receipt.paid_by}
          onChange={(e) => setReceipt({...receipt, paid_by: e.target.value})}
        />
      </div>
      <div id='select-payment-options-label' >Select one or more payment options:</div>
      <div id='payment-options-buttons-container'>
        <button onClick={onClickAddCash} className='pospro-action-btn payment-option-button'>Cash</button>
        <button onClick={onClickAddCheque} className='pospro-action-btn payment-option-button'>Cheque</button>
        <button className='pospro-action-btn payment-option-button'>Credit/Debit Card</button>
        <button className='pospro-action-btn payment-option-button'>Sodexo/Gift Checks</button>
        <button className='pospro-action-btn payment-option-button'>Others...</button>
        <button onClick={onClickDiscount} className='pospro-action-btn payment-option-button discounts-btn'>Discounts</button>
      </div>
    </div>
  )
}

function SummaryBlock(props) {
  const receipt = props.receipt[0]
  const { deletePayment } = props
  const payments = receipt.payments
  const totalAmountToPay = receipt.amount_to_pay.total_amount
  const totalAmountPaid = payments.find(item => item.name === 'total_amount_paid').total_amount_paid
  const totalAmountDue = (parseFloat(totalAmountToPay) - parseFloat(receipt.discounts.discount_total.total_discount_amount))
  const totalBalanceChange = (parseFloat(totalAmountDue) - parseFloat(totalAmountPaid))

  const onClickDeletePaymentType = (e) => {
    const paymentName = e.target.closest('.data-container').querySelector('.summary-data-label').innerText
    deletePayment(paymentName)
  }

  return (
    <div id='summary-block-container'>
      <div id='summary-container-label'>Summary</div>
      <div className='data-container'>
        <div className='summary-data-label bold'>Total Amount to Pay</div>
        <div className='summary-data bold'>P {formatNumber(totalAmountToPay)}</div>
      </div>
      <hr />

      <div className='data-container'>
        <div className='summary-data-label bold'>Total Discount ({formatNumber(parseFloat(receipt.discounts.discount_total.total_percent_discount).toFixed(2))}%)</div>
        <div className='summary-data bold'>P{formatNumber(parseFloat(receipt.discounts.discount_total.total_discount_amount).toFixed(2))}</div>
      </div>
      {
        receipt.discounts.items.map((discount, index) => (
          (discount.vat_exempted)
          ?
            <div key={index} className='data-container discounts'>
              <div className='summary-data-label'>
                {discount.discount_authority_name} (VAT Exempted)
                &nbsp;({parseFloat(discount.percent_discount).toFixed(2)}%)
              </div>
              <div className='summary-data'>
                P{formatNumber(parseFloat(discount.discount_amount).toFixed(2))}
              </div>
            </div>
          :
            <div key={index} className='data-container discounts'>
              <div className='summary-data-label'>
                {discount.discount_authority_name}
                &nbsp;({formatNumber(parseFloat(discount.percent_discount).toFixed(2))}%)
              </div>
              <div className='summary-data'>P{formatNumber(parseFloat(discount.discount_amount).toFixed(2))}</div>
            </div>
        ))
      }
      <hr />

      <div className='data-container'>
        <div className='summary-data-label bold'>Total Amount Due</div>
        <div className='summary-data bold'>P{formatNumber(parseFloat(totalAmountDue).toFixed(2))}</div>
      </div>
      <hr />

      {
        (payments) ?
          payments.map((payment, index) => (
            (payment.name.search('total_') !== -1) ? null :
              <div key={index} className='data-container'>
                <div className='delete-button-container'>
                  <CloseButton onClick={onClickDeletePaymentType} title='remove payment'/>
                </div>
                <div className='summary-data-label'>{payment.name}</div>
                <div className='summary-data'>P {formatNumber(payment.total)}</div>
              </div>
          ))
        : null
      }

      <hr />
      <div className='data-container'>
        <div className='summary-data-label bold'>Total Amount Received</div>
        <div className='summary-data bold'>P {formatNumber(totalAmountPaid)}</div>
      </div>

      <div className='data-container' style={{display: (totalBalanceChange === 0) ? 'none' : 'flex'}}>
        <div className='summary-data-label red bold'>{(totalBalanceChange > 0) ? <span>Balance</span> : <span>Change</span>}</div>
        <div className='summary-data red bold'>P {formatNumber(Math.abs(totalBalanceChange))}</div>
      </div>
    </div>
  )
}

function ReceiptInner() {
  const receiptController = useContext(receiptControllerContext)
  const { addPayments, deletePayment } = receiptController
  const [receipt, setReceipt] = receiptController.receipt
  const receiptsList = receiptController.receiptsList[0]

  const paymentOptionsBlockProps = {
    receipt: [receipt, setReceipt],
    receiptsList,
    addPayments
  }

  const summaryBlockProps = {
    receipt: [receipt, setReceipt],
    deletePayment
  }

  return (
    <ContentInner>
      <div id='receipt-inner-container'>
        <PaymentOptionsBlock { ...paymentOptionsBlockProps }/>
        <SummaryBlock { ...summaryBlockProps }/>
      </div>
      <ReceiptInnerStyle />
    </ContentInner>
  )
}

export default React.memo(ReceiptInner)
